import { useMemo } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CustomFormRow } from "./CustomFormRow";
import { ICustomForm, IStoreCustomFormGrid } from "../DataTypes/storeTypes";
import { goHome } from "../Actions/actions";
import { getTimeZoneText } from "../../../Common/timeZoneUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Button, palette, Typography } from "@powerdiary/components-library/lib";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const NoForms = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    const containerSx = {
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "0" : "24px",
        flexDirection: isMobile ? "column" : "row",
    };

    const typographySx = {
        textAlign: isMobile ? "center" : "left",
    };

    return (
        <Box
            style={{
                borderRadius: "8px",
                border: `1px solid ${palette.neutral[300]}`,
                padding: "24px",
            }}
        >
            <Box sx={containerSx}>
                <img src="/images/empty-states/forms.svg" alt="No forms" />
                <Box display="flex" flexDirection="column" gap="8px" justifyContent="center">
                    <Typography variant="heading4" sx={typographySx}>
                        You don't have any forms yet
                    </Typography>
                    <Typography variant="paragraphMediumRegular" sx={typographySx}>
                        When you receive forms, they'll appear here for easy access. Stay organized and keep track of
                        everything in one place.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export const CustomFormGrid = () => {
    const { forms, timeZoneText } = useSelector((state: IStoreCustomFormGrid) => {
        const {
            initialSettings: { forms },
        } = state;

        return {
            forms: forms,
            timeZoneText: getTimeZoneText(),
        };
    });
    const dispatch = useDispatch();

    const rows = useMemo(() => {
        return forms.map((customForm: ICustomForm) => (
            <CustomFormRow customForm={customForm} key={customForm.customFormDataNumber} />
        ));
    }, [forms]);

    return (
        <div className="custom-form-page">
            <div className="row">
                <div className="col-lg-10 col-12 ml-lg-auto mr-lg-auto fit-height-scroll">
                    <div className="row">
                        <div className="col text-center">
                            <Button
                                variant="contained"
                                size="medium"
                                className="float-left mt-3 mt-md-2"
                                onClick={() => dispatch(goHome())}
                            >
                                <FontAwesomeIcon icon={faHome} />
                            </Button>

                            <div>
                                <h3 className="question">Your forms</h3>
                                <div className="mt-2">{timeZoneText}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row custom-form-container">
                        <div className="col-12">{rows.length ? rows : <NoForms />}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
